import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://nsridxosckrjwfamhnbc.supabase.co'  // ← il tuo Project URL
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5zcmlkeG9zY2tyandmYW1obmJjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU4MTY3NjIsImV4cCI6MjA5MTM5Mjc2Mn0.HP7OFJPLuEnaF36RhEzDyZvCxNdAbwV8_oJxIwGwzF4'                      // ← la tua anon public key

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)